<div class="profile-container">
    <div class="profile-content">

        <!-- Profile Header -->
        <div class="profile-header">
            <div>
                <!-- <span class="profile-eyebrow">ACCOUNT SETTINGS</span> -->
                <h2>My Profile</h2>
                <p>Manage your personal information and application preferences.</p>
            </div>
        </div>

        <!-- Personal Details -->
        <div class="personal-details">

            <div class="section-title">
                <div>
                    <h4>Personal Details</h4>
                    <p>Your account information</p>
                </div>
            </div>

            <div class="profile-main">

                <!-- Profile Image -->
                <div class="profile-avatar-section">
                    <div class="user-profile-image">
                        <img src="assets/img/dummy-image.jpeg" class="img-avatar" alt="User profile" />
                    </div>

                    <div class="avatar-status">
                        <span class="status-dot"></span>
                        Active
                    </div>
                </div>

                <!-- Profile Information -->
                <div class="user-profile-data">

                    <div class="form-field">
                        <label>Name</label>
                        <input type="text" readonly [value]="userCred.userName" class="form-control" />
                    </div>

                    <div class="form-field">
                        <label>Email</label>
                        <input type="text" readonly [value]="userCred.userEmail" class="form-control" />
                    </div>

                    <div class="form-field">
                        <label>Mobile</label>
                        <input type="text" readonly [value]="userCred.userMobileNo" class="form-control" />
                    </div>

                    <div class="form-field">
                        <label>User Type</label>
                        <input type="text" readonly [value]="userCred.userType" class="form-control" />
                    </div>

                    <div class="form-field">
                        <label>Role</label>
                        <input type="text" readonly [value]="userCred.roleName[0]" class="form-control" />
                    </div>

                    <div class="form-field">
                        <label>Authentication Mode</label>

                        <select class="form-control" (change)="authChanged($event)" [(ngModel)]="authMode">
                            <option value="1">1 Step Authentication</option>
                            <option value="2">2 Step Authentication</option>
                        </select>
                    </div>

                    <div class="form-field">
                        <label>Menu Display</label>

                        <select name="menuDisplay" id="menuDisplay" class="form-control"
                            (change)="menuDisplayChanged($event)" [(ngModel)]="isFavouriteList">
                            <option [value]="false">All</option>
                            <option [value]="true">Favourite</option>
                        </select>
                    </div>

                    <div class="form-field">
                        <label>Language</label>

                        <select id="lang" class="form-control" [(ngModel)]="selectedLang"
                            (change)="updateUserPreference()">
                            <option *ngFor="let lang of languages" [value]="lang.value">
                                {{ lang.label }}
                            </option>
                        </select>
                    </div>

                    <!-- TPM -->
                    <div class="form-field" *ngIf="isTpmEnable">
                        <label>Security</label>

                        <button class="btn-primary" data-toggle="modal" data-target="#tpmModal">
                            Register TPM
                        </button>
                    </div>

                </div>
            </div>
        </div>


        <!-- Selected Menus -->
        <div class="selected-menus">

            <div class="section-title">
                <div>
                    <h4>Selected Menus</h4>
                    <p>Menus and modules available for your account</p>
                </div>
                <button class="btn-primary" (click)="updateFavouriteList()">
                    Save Favourites
                </button>
            </div>

            <div class="menu-groups">

                <div class="menu-group" *ngFor="let rolePrevilage of userPrivileges; let i = index">

                    <!-- Group Header -->
                    <div class="menu-group-header">
                        <div class="group-icon">
                            <i class="bi bi-grid"></i>
                        </div>

                        <div>
                            <h5>{{ rolePrevilage.groupName }}</h5>
                            <span>
                                {{ rolePrevilage.screenPrivilegeList.length }} menus
                            </span>
                        </div>

                        <div style="margin-left: auto;">
                            <label class="menu-checkbox" for="menu_{{i}}">
                                <input class="form-check-input" type="checkbox" [(ngModel)]="rolePrevilage.isMenu"
                                    (ngModelChange)="onMenuChange(rolePrevilage)" id="menu_{{i}}" />
                                <span class="custom-check">
                                    <i class="bi bi-check"></i>
                                </span>
                                <span class="menu-name">Menu</span>
                            </label>
                        </div>
                    </div>

                    <!-- Menu Items -->
                    <div class="menu-list">

                        <div class="menu-item" *ngFor="
                let screenPrivilegeList of rolePrevilage.screenPrivilegeList;
                let j = index
              ">

                            <label class="menu-checkbox" for="privilege_{{i}}_{{j}}">

                                <input class="form-check-input" type="checkbox" [(ngModel)]="screenPrivilegeList.isSubMenu"
                                    (ngModelChange)="onSubMenuChange(rolePrevilage)" id="privilege_{{i}}_{{j}}" />

                                <span class="custom-check">
                                    <i class="bi bi-check"></i>
                                </span>

                                <span class="menu-name">
                                    {{ screenPrivilegeList.description }}
                                </span>

                            </label>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</div>


<!-- ========================================================= -->
<!-- UPDATE ROLE MODAL -->
<!-- ========================================================= -->

<div class="modal fade" id="updateRole" tabindex="-1" aria-labelledby="updateRoleLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content modern-modal">

            <div class="modal-header">
                <div>
                    <span class="modal-eyebrow">ACCESS MANAGEMENT</span>
                    <h5 class="modal-title" id="updateRoleLabel">
                        Update Role
                    </h5>
                </div>

                <button type="button" class="modal-close" data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <div class="modal-body">

                <div class="role-editor" *ngFor="let role of userPrivileges">

                    <div class="form-field">
                        <label>Role Name</label>
                        <input type="text" class="form-control" />
                    </div>

                    <div class="role-permission" *ngFor="
              let rolePrevilage of role.rolePrevilages;
              let i = index;
              let last = last;
              let first = first
            ">

                        <div class="permission-header">

                            <strong>
                                {{ rolePrevilage.groupName }}
                            </strong>

                            <div class="position-actions">

                                <button *ngIf="!first" (click)="privilegeAdjust(i, 'up')" type="button">
                                    <i class="bi bi-arrow-up"></i>
                                </button>

                                <button *ngIf="!last" (click)="privilegeAdjust(i, 'down')" type="button">
                                    <i class="bi bi-arrow-down"></i>
                                </button>

                            </div>

                        </div>

                        <div class="permission-table">

                            <table>

                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Position</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    <tr *ngFor="
                      let screenPrivilegeList of rolePrevilage.screenPrivilegeList;
                      let j = index;
                      let jlast = last;
                      let jfirst = first
                    ">

                                        <td>
                                            {{ screenPrivilegeList.name }}
                                        </td>

                                        <td>
                                            {{ screenPrivilegeList.description }}
                                        </td>

                                        <td>

                                            <div class="table-actions">

                                                <button *ngIf="!jfirst" (click)="screenPrivilegeListAdjust(i, j, 'up')">
                                                    <i class="bi bi-arrow-up"></i>
                                                </button>

                                                <button *ngIf="!jlast"
                                                    (click)="screenPrivilegeListAdjust(i, j, 'down')">
                                                    <i class="bi bi-arrow-down"></i>
                                                </button>

                                            </div>

                                        </td>

                                    </tr>

                                </tbody>

                            </table>

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button type="button" id="closeModalButton" class="btn-secondary" data-dismiss="modal">
                    Cancel
                </button>

                <button type="button" class="btn-primary" (click)="updatePosition()">
                    Save Changes
                </button>

            </div>

        </div>
    </div>
</div>


<!-- ========================================================= -->
<!-- AUTHENTICATION MODALS AND BUTTONS -->
<!-- ========================================================= -->

<button id="authButton" class="btn btn-primary" data-toggle="modal" data-target="#authModal"
    [style.display]="'none'">auth</button>

<div class="modal fade" id="authModal" tabindex="-1" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content modern-modal">

            <div class="modal-header">
                <div>
                    <span class="modal-eyebrow">SECURITY</span>
                    <h5 class="modal-title">Authentication</h5>
                </div>

                <button type="button" class="modal-close" data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <div class="modal-body">

                <div class="qr-wrapper" *ngIf="qrCode">
                    <img [src]="qrCode" alt="Authentication QR Code" />
                    <p>Scan this QR code using your authenticator application.</p>
                </div>

                <div class="form-field">
                    <label>Enter OTP</label>

                    <input type="text" class="form-control" [(ngModel)]="otp" placeholder="Enter verification code" />
                </div>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn-secondary" (click)="cancelQrCode()" data-dismiss="modal">
                    Cancel
                </button>

                <button type="button" class="btn-success" (click)="update()">
                    Registration Done
                </button>

            </div>

        </div>
    </div>
</div>

<button id="authButton1" class="btn btn-primary" data-toggle="modal" data-target="#authModal2"
    [style.display]="'none'">auth</button>

<div class="modal fade" id="authModal2" tabindex="-1" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content modern-modal">

            <div class="modal-header">
                <div>
                    <span class="modal-eyebrow">SECURITY</span>
                    <h5 class="modal-title">Authentication</h5>
                </div>

                <button type="button" class="modal-close" data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <div class="modal-body">
                <div class="form-group qr-wrapper">
                    <p>Switch to 1 step authentication.</p>
                </div>
                <div class="form-field">
                    <label>Enter OTP</label>

                    <input type="text" class="form-control" [(ngModel)]="otp" placeholder="Enter verification code" />
                </div>

            </div>

            <div class="modal-footer">

                <button type="button" class="btn-secondary" (click)="cancelQrCode()" data-dismiss="modal">
                    Cancel
                </button>

                <button type="button" class="btn-success" (click)="update()">
                    Confirm
                </button>

            </div>

        </div>
    </div>
</div>

<!-- ========================================================= -->
<!-- TPM MODAL -->
<!-- ========================================================= -->

<div class="modal fade" id="tpmModal" tabindex="-1" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content modern-modal">

            <div class="modal-header">

                <div>
                    <span class="modal-eyebrow">SECURITY</span>
                    <h5 class="modal-title">
                        Register TPM
                    </h5>
                </div>

                <button type="button" class="modal-close" data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </button>

            </div>

            <div class="modal-body">

                <div class="form-field">
                    <label>Registrar OTP</label>

                    <input type="text" class="form-control" [(ngModel)]="tpmForm.registrarOtp" />
                </div>

                <div class="form-field">
                    <label>To Be Registered Username</label>

                    <input type="text" class="form-control" [(ngModel)]="tpmForm.toBeRegisteredUsername" />
                </div>

                <div class="form-field">
                    <label>To Be Registered Password</label>

                    <input type="password" class="form-control" [(ngModel)]="tpmForm.toBeRegisteredPassword" />
                </div>

                <div class="form-field">
                    <label>To Be Registered OTP</label>

                    <input type="text" class="form-control" [(ngModel)]="tpmForm.toBeRegisteredOtp" />
                </div>

            </div>

            <div class="modal-footer">

                <button type="button" id="closeTpmModalButton" class="btn-secondary" data-dismiss="modal">
                    Cancel
                </button>

                <button type="button" class="btn-success" (click)="submitTpmRegistration()">
                    Register
                </button>

            </div>

        </div>
    </div>
</div>

<button id="passwordPromptButton" class="btn btn-primary" data-toggle="modal" data-target="#passwordPromptModal"
    [style.display]="'none'">passwordPrompt</button>

<div class="modal fade" id="passwordPromptModal" tabindex="-1" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">

        <div class="modal-content modern-modal">

            <div class="modal-header">
                <div>
                    <span class="modal-eyebrow">SECURITY</span>
                    <h5 class="modal-title">Authentication</h5>
                </div>

                <button type="button" class="modal-close" data-dismiss="modal">
                    <i class="bi bi-x-lg"></i>
                </button>
            </div>

            <div class="modal-body">
                <div class="form-field">
                    <label>Please enter your password to register TPM:</label>

                    <input type="password" class="form-control" [(ngModel)]="registrarPassword" />
                </div>

            </div>

            <div class="modal-footer">

                <button type="button" id="closePasswordPromptButton" class="btn-secondary" data-dismiss="modal">
                    Cancel
                </button>

                <button type="button" class="btn-success" (click)="registerOtp()">
                    Confirm
                </button>

            </div>

        </div>
    </div>
</div>